import { injectIntl } from "react-intl";
import { Formik } from "formik";
import Heading from "../Heading";
import { ActionBar } from "../ActionBar";
import { intlShape } from "../../shapes";
import { formatDateTime } from "../../utils";
import { Form, TextArea, SubmitButton, CancelButton } from "../Form";

type Props = {
  intl?: intlShape;
  showCreateForm?: boolean;
  onSubmit?: $TSFixMeFunction;
  comments?: {
    id?: number;
    comment?: string;
    created_at?: string;
    created_by?: string;
  }[];
};

export function Comments({ comments, intl, showCreateForm, onSubmit }: Props) {
  const renderForm = (formProps: $TSFixMe) => {
    const { isSubmitting } = formProps;
    return (
      <Form id="ticket-form" {...formProps}>
        <TextArea
          {...formProps}
          id="ticket-comment"
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          label={intl.formatMessage({ id: "label.new_comment" })}
          disabled={isSubmitting}
          name="comment"
          required
          cols={50}
          rows={5}
        />
        <div className="btn-group">
          <SubmitButton
            id="comment-submit"
            fetching={isSubmitting}
            disabled={!formProps.dirty}
          />
          <CancelButton
            id="comment-cancel"
            fetching={isSubmitting}
            // @ts-expect-error TS(2322) FIXME: Type '{ id: string; fetching: any; intl: intlShape... Remove this comment to see the full error message
            intl={intl}
          />
        </div>
      </Form>
    );
  };

  return (
    <div>
      <ActionBar>
        <Heading
          level={2}
          id="ticket-comments-header"
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          title={intl.formatMessage({ id: "support.ticket.comments.header" })}
        />
      </ActionBar>
      <ul id="ticket-comments-list" className="list">
        {comments?.map((comment) => (
          <li className="list-item" key={comment.id}>
            <div className="list-item-content support-wrap">
              <span className="strong">{comment.comment}</span>
              <div id={`ticket-comment-author-${comment.id}`}>
                {`${formatDateTime(comment.created_at, intl)} - ${comment.created_by}`}
              </div>
            </div>
          </li>
        ))}
      </ul>
      {showCreateForm && (
        // @ts-expect-error TS(2322) FIXME: Type '$TSFixMeFunction | undefined' is not assigna... Remove this comment to see the full error message
        <Formik id="comment-form" onSubmit={onSubmit} initialValues={{}}>
          {renderForm}
        </Formik>
      )}
    </div>
  );
}
export default injectIntl(Comments);
